<template>
  <b-modal
    id="view-question-modal"
    title="Question Details"
    size="lg"
    hide-footer
    centered
  >
    <div v-if="question.id">
      <!-- Question Text -->
      <div class="mb-4">
        <h5 class="mb-2">
          Question
        </h5>
        <div class="question-content p-3 bg-light rounded">
          <div class="mb-2">
            <strong>English:</strong> {{ question.text }}
          </div>
          <div v-if="question.text_ar">
            <strong>Arabic:</strong> {{ question.text_ar }}
          </div>
        </div>
      </div>

      <!-- Answers -->
      <div class="mb-4">
        <h5 class="mb-3">
          Answers
        </h5>
        <div class="answers-list">
          <div
            v-for="(answer, index) in question.answers"
            :key="answer.id"
            class="answer-item mb-3 p-3 border rounded"
            :class="{
              'border-success bg-success-light': answer.is_correct,
              'border-secondary': !answer.is_correct
            }"
          >
            <div class="d-flex align-items-start">
              <b-badge
                :variant="answer.is_correct ? 'success' : 'secondary'"
                class="mr-2 mt-1"
                style="min-width: 24px;"
              >
                {{ String.fromCharCode(65 + index) }}
              </b-badge>
              <div class="flex-grow-1">
                <div class="mb-1">
                  <span
                    :class="{ 'font-weight-bold': answer.is_correct }"
                  >
                    {{ answer.text }}
                  </span>
                  <b-badge
                    v-if="answer.is_correct"
                    variant="success"
                    class="ml-2"
                  >
                    Correct
                  </b-badge>
                </div>
                <div
                  v-if="answer.text_ar"
                  class="text-muted small"
                >
                  {{ answer.text_ar }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Question Info -->
      <div class="question-info border-top pt-3">
        <div class="row">
          <div class="col-md-6">
            <small class="text-muted">
              <strong>Created:</strong> {{ formatDate(question.created_at) }}
            </small>
          </div>
          <div class="col-md-6">
            <small class="text-muted">
              <strong>Updated:</strong> {{ formatDate(question.updated_at) }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <b-button
          variant="outline-secondary"
          @click="$bvModal.hide('view-question-modal')"
        >
          Close
        </b-button>
        <div>
          <b-button
            variant="outline-primary"
            class="mr-2"
            @click="editQuestion"
          >
            <feather-icon
              icon="EditIcon"
              size="16"
              class="mr-1"
            />
            Edit Question
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
    BBadge,
  },
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const formatDate = dateString => {
      if (!dateString) return '-'
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }

    const editQuestion = () => {
      ctx.root.$bvModal.hide('view-question-modal')
      ctx.root.$router.push(`/learning-center-quiz/edit/${props.question.id}`)
    }

    return {
      formatDate,
      editQuestion,
    }
  },
}
</script>

<style scoped>
.question-content {
  font-size: 1.1rem;
  line-height: 1.5;
}

.answer-item {
  transition: all 0.2s ease;
}

.answer-item:hover {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.bg-success-light {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

.answers-list {
  max-height: 400px;
  overflow-y: auto;
}
</style>
